import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Modal, RadioGroup } from 'wix-style-react'
import MessageBoxFunctionalLayout from 'components/shared/MessageBoxFunctionalLayout'
import Cropper from 'react-cropper'
import PortraitIcon from 'react-icons/lib/md/crop-portrait'
import FreeIcon from 'react-icons/lib/md/crop-free'
import SquareIcon from 'react-icons/lib/md/crop-square'
import _ from 'lodash'

import Text from 'components/common/Text'
import 'cropperjs/dist/cropper.css'

const Container = styled.div`
  display: flex;
  height: 36em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const RadioContainer = styled.div`
  flex: 1;
  margin-top: 1em;
  align-items: center;
`
const RadioHeader = styled.div`
  margin-bottom: 0.5em;
  display: flex;
  align-self: center;
`

const ASPECT_RATIO_9_16 = 0
const ASPECT_RATIO_1_1 = 1
const ASPECT_RATIO_CUSTOM = 2

class ImageCrop extends Component {

  constructor (props) {
    super(props)
    this.state = {
      aspectRatio: ASPECT_RATIO_CUSTOM
    }
  }

  onClose = () => {
    const { onComplete } = this.props
    onComplete(null)
  }

  onImageLoaded = (crop) => {
  }

  onCropperMounted = (ref) => {
    this.cropper = ref
  }

  onAspectRatioChanged = (v) => {
    this.setState({aspectRatio: v})
  }

  getAspectRatio = () => {
    const { aspectRatio } = this.state
    switch (aspectRatio) {
      case ASPECT_RATIO_9_16: return 9 / 16
      case ASPECT_RATIO_1_1: return 1
      default: return null
    }
  }

  renderContent () {
    const { file } = this.props
    const { aspectRatio } = this.state
    const realAspectRatio = this.getAspectRatio()
    const src = _.isObject(file) ? window.URL.createObjectURL(file) : file
    return (
      <Container id='cropper'>
        {/* <ImageContainer> */}
        <Cropper
          style={{ height: '34em', width: '100%', zIndex: 1000 }}
          aspectRatio={realAspectRatio}
          preview='.img-preview'
          guides
          src={src}
          ref={this.onCropperMounted}
          zoomable={false}
          viewMode={1}
          autoCropArea={1}
        />
        <RadioContainer className='ltr'>
          <RadioHeader>
            <Text>Aspect ratio</Text>
          </RadioHeader>
          <RadioGroup
            display='horizontal'
            type='button'
            value={aspectRatio}
            onChange={this.onAspectRatioChanged}
            lineHeight='50px'
            name={'radio_group_name'}
          >
            <RadioGroup.Radio
              key={ASPECT_RATIO_9_16}
              value={ASPECT_RATIO_9_16}
              name={'9 / 16'}
              vAlign='center'
              icon={<PortraitIcon size='20px' />}
            >
              <Text>Portrait</Text>
            </RadioGroup.Radio>

            <RadioGroup.Radio
              key={ASPECT_RATIO_1_1}
              value={ASPECT_RATIO_1_1}
              name={'1 / 1'}
              icon={<SquareIcon size='20px' />}
            >
              <Text>Square</Text>
            </RadioGroup.Radio>

            <RadioGroup.Radio
              key={ASPECT_RATIO_CUSTOM}
              value={ASPECT_RATIO_CUSTOM}
              name={'Custom'}
              icon={<FreeIcon size='20px' />}
            >
              <Text>Any</Text>
            </RadioGroup.Radio>

          </RadioGroup>
        </RadioContainer>
      </Container>
    )
  }

  onClose = () => {
    const { file, onComplete } = this.props
    onComplete(file)
  }

  srcToFile (src, fileName, mimeType) {
    return (fetch(src)
      .then(res => res.arrayBuffer())
      .then(buf => new File([buf], fileName, {type: mimeType}))
    )
}

  onApply = () => {
    const { file, onComplete, assetInfo } = this.props
    const src = this.cropper.getCroppedCanvas().toDataURL()
    const fileName = _.get(assetInfo, 'name', file.name)
    const fileType = _.get(assetInfo, 'type', file.type)
    this.srcToFile(src, fileName, fileType).then(croppedFile => {
      onComplete(croppedFile)
    })
  }

  render () {
    return (
      <Modal
        isOpen
        contentLabel='image crop modal'
        theme='blue'
        zIndex={1000001}
        onCancel={this.onClose}
      >
        <div id='cropper'>
          <MessageBoxFunctionalLayout
            theme='blue'
            title='Image crop'
            onCancel={this.onClose}
            confirmText='Crop'
            cancelText='Leave as is'
            width='60em'
            onOk={this.onApply}
          >
            {this.renderContent()}
          </MessageBoxFunctionalLayout>
        </div>
      </Modal>
    )
  }
}

ImageCrop.propTypes = {
  file: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]),
  onComplete: PropTypes.func.isRequired,
  assetInfo: PropTypes.object
}

export default connect()(ImageCrop)



// WEBPACK FOOTER //
// ./src/components/editor/assetsManager/ImageCrop.js